import { createMetricsFactory } from 'metrics-js';
import { METRIC_NAMES } from './constants';
import { safeCallback } from '../utils';
const Metrics = createMetricsFactory('magpie');
export const MetricsReporter = {
  reportMessageSent: safeCallback(({
    appName,
    topicName,
    messageType
  }) => {
    Metrics.counter(METRIC_NAMES.MESSAGE_COUNT, {
      appName,
      topicName,
      messageType
    }).increment();
  }),
  reportMessageLatency: safeCallback(({
    appName,
    topicName,
    messageType
  }, latency) => {
    Metrics.timer(METRIC_NAMES.MESSAGE_LATENCY, {
      appName,
      topicName,
      messageType
    }).update(latency);
  }),
  reportValidationError: safeCallback(({
    appName,
    topicName,
    messageType
  }) => {
    Metrics.counter(METRIC_NAMES.VALIDATION_ERROR_COUNT, {
      appName,
      topicName,
      messageType
    }).increment();
  }),
  reportConnectionError: safeCallback(({
    appName,
    status
  }) => {
    Metrics.counter(METRIC_NAMES.CONNECTION_ERROR_COUNT, {
      appName,
      status
    }).increment();
  }),
  reportHandshakeCompleted: safeCallback(({
    appName
  }, latency) => {
    Metrics.counter(METRIC_NAMES.HANDSHAKE_COMPLETED, {
      appName
    }).increment();
    Metrics.timer(METRIC_NAMES.HANDSHAKE_LATENCY, {
      appName
    }).update(latency);
  })
};